import type { ToastOptions } from '../../contexts/toast/toast-context';

type ToastHandler = (options: ToastOptions) => void;
type DismissHandler = () => void;

let showHandler: ToastHandler | null = null;
let dismissHandler: DismissHandler | null = null;

export const toastEmitter = {
  register(show: ToastHandler, dismiss: DismissHandler) {
    showHandler = show;
    dismissHandler = dismiss;
  },
  showToast(options: ToastOptions) {
    showHandler?.(options);
  },
  dismissToast() {
    dismissHandler?.();
  },
}
